import React from 'react';

import { ExclamationCircleFilled } from '@ant-design/icons';
import { Modal } from 'antd';

interface ComponentProps {
  selectedRowKeys: string[];
  onDelete: () => void;
}

export const showCustomPoiDeleteModal = ({ selectedRowKeys, onDelete }: ComponentProps) => {
  const isPlural = selectedRowKeys.length > 1;
  const modelKeyWord = isPlural ? 'locations' : 'location';

  const getTitle = () => `Remove ${modelKeyWord}`;

  const getContent = () => {
    return (
      <>
        <p>Are you sure you want to remove the selected {modelKeyWord}?</p>
      </>
    );
  };

  return Modal.confirm({
    title: getTitle(),
    icon: <ExclamationCircleFilled />,
    content: getContent(),
    okText: getTitle(),
    okButtonProps: { type: 'danger' },
    onOk() {
      onDelete();
    }
  });
};
